import React, { useState } from 'react'
import WotcDisclaimer from './WotcDisclaimer'
import WotcAssessment from './WotcAssessment'
import queryString from 'query-string'
import Redirect from '../../services/redirect'

const WotcStep = (props) => {
  const [activeSection, setActiveSection] = useState(props.actSection)
  const redirect = queryString.parse(window.location.search).redirect

  const handleNewSection = (section) => {
    setActiveSection(section)
  }

  const handleNext = () => {
    Redirect.navigate(redirect)
  }

  const onLoad = () => {
    try {
      if (redirect && document.getElementById('wotc-redirect').contentWindow.document) {
        Redirect.navigate(redirect)
      }
    } catch (error) {}
  }

  switch (activeSection) {
    case 'disclaimer':
      return (<WotcDisclaimer onHandleNext={handleNext} handleNewSection={handleNewSection} />)
    case 'assessment':
      return (<WotcAssessment onLoad={onLoad} onHandleNext={handleNext} handleNewSection={handleNewSection} />)
    default:
      return null
  }
}

export default WotcStep
